import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, from, map, take } from 'rxjs';
import { AuthService } from '../core-services/auth.service';
import { AnalyticsService } from '../core-services/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router,
    private analytics: AnalyticsService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // Convert the Firebase Auth check into an Observable
      return from(this.authService.checkAuthStatus()).pipe(
        take(1), // Take only one value and complete the stream
        map(isAuthenticated => {
          if (isAuthenticated) {
            return true;
          } else {
            this.router.navigate(['/login']); // , { queryParams: { returnUrl: state.url }}
            return false;
          }
        })
      );
  }
}